import {
  deleteUser as deleteUserApi,
} from "../../../helpers/user_helper.js";
import { userDeleteSuccess, userDeleteError } from "./reducer";

export const deleteUser = (id) => async (dispatch) => {
  try {
    let response;
    response = deleteUserApi(id);
    const data = await response;
    if (data) {
      dispatch(userDeleteSuccess());
    }
  } catch (error) {
    dispatch(userDeleteError(error));
  }
};
